import React, { Component, componentDidMount } from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";

class MethodBox extends Component {

    componentDidMount() {
        Aos.init({ duration: 700,
            delay:200});
    }

    render(){
    return (
        <div className="method-box">
            <div className="method-connect" data-aos="fade-up">
                <img src={this.props.img}/>
                <div className="method-connect-circle" id={this.props.position}/>
            </div>
            <div className="method-text"data-aos="fade-up">
                <h1>{this.props.title}</h1>
                <p>{this.props.text}</p>
            </div>
            <div className="method-number" id={this.props.style}>
                {this.props.number}
            </div>
        </div>
    )
    }
}

export default MethodBox
